import React from 'react';
import { observer } from 'mobx-react';
import { formatMessage } from '../../../translations/format-message';
import { useStore } from '../../../contexts/store-provider';
import { useOperatorTaskContext, InfoField } from '../context/operator-task-context';
import OperatorHorizontalView from './../views/operator-horizontal-view';
import OperatorVerticalView from './../views/operator-vertical-view';

type OperatorAssignModeContentProps = Partial<{
  infoFields: InfoField[];
  trayHistory: string[];
  operatorResponseViewType: number;
  viewProps: any;
}>;

const OperatorAssignModeContent = observer((props: OperatorAssignModeContentProps) => {
  const context = useOperatorTaskContext();
  const { operatorStore } = useStore();

  const infoFields = props.infoFields ?? context.infoFields ?? [];
  const trayHistory = props.trayHistory ?? context.trayHistory ?? [];
  const operatorResponseViewType =
    props.operatorResponseViewType ?? operatorStore.OperatorResponse?.ViewType ?? 1;
  const viewProps = props.viewProps ?? context.viewProps ?? {};

  return (
    <div className="card tray-data opertor-dummy">
      <div className="operator-assign p-0">
        <div>
          <div className="row g-0 tray-data-header justify-space-between p-0 mb-1">
            {infoFields.map(({ labelKey, value, colWidth }, index) => (
              <div
                className={`katashiki-width col-${colWidth}${
                  labelKey === 'reprocess_items' ? ' reprocess-items-ribbon' : ''
                }`}
                key={index}
                title={String(value ?? '')}
              >
                <p className="small text-muted">{formatMessage(labelKey)}</p>
                <p className="text-dark kisu-table ">{value || '-'}</p>
              </div>
            ))}
          </div>
          {trayHistory.length > 0 ? (
            operatorResponseViewType === 1 ? (
              <OperatorHorizontalView {...viewProps} />
            ) : (
              <OperatorVerticalView {...viewProps} />
            )
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
});

export default OperatorAssignModeContent;
